/* Devino Blueprint v2 — motion & micro-interactions.
   No scroll reveals: content is never JS-hidden (R7 — reveal-on-scroll held
   below-fold sections at opacity:0, hurting LCP and non-scrolling visitors). */
(() => {
  // Sticky mobile add-to-cart: an ancestor (.product__info-wrapper) carries a
  // transform from Dawn's scroll animation, which turns it into the containing
  // block for position:fixed and pins the bar mid-page instead of to the
  // viewport. Re-parent to <body> — the button's form="" attribute keeps it
  // wired to the product form from anywhere in the document.
  document.querySelectorAll('.dv-satc').forEach((el) => document.body.appendChild(el));

  // The bar only renders when some variant is in stock (templates/product.json).
  // It mirrors the main button, which Dawn disables and relabels "Sold out" /
  // "Unavailable" when the selected variant can't be bought.
  document.querySelectorAll('.dv-satc button[form]').forEach((sticky) => {
    const main = document.getElementById(sticky.getAttribute('form'))?.querySelector('button[name="add"]');
    if (!main) return;
    const sync = () => {
      sticky.disabled = main.disabled;
      sticky.textContent = (main.querySelector('span') || main).textContent.trim();
    };
    sync();
    new MutationObserver(sync).observe(main, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true,
    });
  });

  const closeSearch = () => {
    document.querySelectorAll('predictive-search[open]').forEach((ps) => {
      if (typeof ps.close === 'function') ps.close(false);
      else ps.removeAttribute('open');
    });
  };
  const closeMobileNav = () => {
    document.querySelectorAll('details.dv-mobile[open]').forEach((d) => d.removeAttribute('open'));
  };

  // Header dropdowns are mutually exclusive: opening the burger menu closes
  // the search results and vice versa, so the two sheets never stack.
  document.querySelectorAll('.dv-burger').forEach((b) => b.addEventListener('click', closeSearch));
  document.querySelectorAll('.dv-search input[type="search"]').forEach((inp) =>
    inp.addEventListener('focus', closeMobileNav)
  );

  // Brands + mobile menus: close on outside click / Escape.
  document.addEventListener('click', (ev) => {
    document.querySelectorAll('details.dv-brmenu[open], details.dv-mobile[open]').forEach((d) => {
      if (!d.contains(ev.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', (ev) => {
    if (ev.key === 'Escape') {
      document
        .querySelectorAll('details.dv-brmenu[open], details.dv-mobile[open]')
        .forEach((d) => d.removeAttribute('open'));
    }
  });
})();
